<template>
    <section class="layout-login">
        <div class="content">
            <div class="d-flex-item">
                <p class="line-h-0">
                    <img src="static/img/login-bg.png">
                </p>
            </div>
            <div class="d-flex-item">
                <div class="d-flex justify-center height-all">
                    <div class="d-block width-all" style="padding: 48px;">
                        <h6 class="align-center">
                            <img class="height-140" src="static/img/logo@256px.png">
                        </h6>
                        <br/>
                        <h2>账户登录</h2>
                        <div class="d-block mtb-xl">
                            <Input prefix="md-contact" size="large" type="text" v-model="loginData.loginName" placeholder="会员号/用户名"/>
                        </div>
                        <div class="d-block mtb-xl">
                            <Input prefix="md-lock" size="large" type="password" v-model="loginData.password" placeholder="密码"/>
                        </div>
                        <p class="d-block mtb-xl" v-if="false">
                            <router-link to="reset">忘记密码？</router-link>
                        </p>
                        <div class="d-block mtb-xl">
                            <Button long type="primary" shape="circle" size="large" :loading="loading" @click="submitLogin">登录</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <p>Copyright © 2021 admin.3rddata.com All Rights Ressrved 版权所有.第三脑域（北京）科技有限公司</p>
            <p>京ICP备2021003543号</p>
        </div>
    </section>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {
                loading: false,
                loginData: {
                    loginName: '',
                    password: '',
                }
            }
        },
        mounted() {
            this.enterLogin();
        },
        methods: {
            enterLogin() {
                var that = this;
                document.onkeydown = function (e) {
                    let keyCode = window.event.keyCode;
                    // 按回车键enter
                    if (keyCode === 13) {
                        that.submitLogin();
                    }
                }
            },
            async submitLogin() {
                if (this.verifyLogin(this.loginData)) {
                    this.loading = true;
                    let resHost = await this.$api.uploadHttp('login', this.loginData);
                    console.log('服务器登录成功---------->', resHost);
                    let resLocal = await this.$api.postHttp('login', this.loginData);
                    console.log('本地登录成功---------->', resLocal);
                    if (resHost.data.code !== 0 && resLocal.data.code !== 0) {
                        await window.VUE.$common.alertModel('error', '登录失败：账号/密码错误请重新输入');
                        this.loading = false;
                        return false;
                    }
                    let data = resLocal.data.data;
                    // debugger
                    if (data.roleId === 1 && data.member.businessName === ''){
                        data.member.businessName = data.user.realName;
                    }
                    if (data.roleId > 2 && data.member){
                        data.member.businessName = data.user.realName;
                    }
                    localStorage.setItem('accountData', JSON.stringify(data));
                    this.$Message.success(resLocal.data.msg);
                    this.loading = false;
                    setTimeout(()=>{
                        window.location.href = '/';
                    }, 500);
                }
            },
            verifyLogin(data) {
                if (data.loginName === ''){
                    this.$Message.error('账户不能为空');
                    return false;
                } else if (this.loginData.password === '') {
                    this.$Message.error('密码不能为空');
                    return false;
                }
                return true;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/login.vue